import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { Spinner } from 'src/components/Spinner';
import { Logout } from 'src/components/Logout';

export function ValidateEmail() {
  const { isAuthenticated, isLoading, user, error, getAccessTokenSilently, loginWithRedirect } = useAuth0();

  console.log("ValidateEmail:  " + isLoading + " " + isAuthenticated + " " + user?.email_verified);
  const params = new URLSearchParams(document.location.search);
  const navigate = useNavigate();

  if (isLoading) {
    return <Spinner />
  }


  useEffect(() => {
    if (user && user.email_verified) {
      navigate("/")
    }
  }, [user, user?.email_verified])

  useEffect(() => {
    console.log('Got authentication: ' + user?.sub)
  }, [isAuthenticated])

  const errMsg = params.get("error_description");
  let userEmail = "";
  if (errMsg?.match(/Email sent to: .*/)) {
    const s = errMsg.split(":");
    userEmail = s[1];
  }


 return (
  <div className="uk-container">
    <h2>Validate Your Email</h2>
    <div className="uk-card uk-card-default uk-card-body">
      <h3 className="uk-card-title">Complete Login</h3>
      {userEmail && 
    <div className="uk-text-primary uk-text-bold">Email sent to {userEmail}</div>}
      <p>
        Please check your email for a validation link to confirm your email address and complete your registration process.
      </p>
      <p>
        <button className="uk-button uk-button-primary"
          onClick={e => loginWithRedirect()}>Resend Email</button>
      </p>
      <p>
        <Logout text="Start Over" />
      </p>

    </div>
  </div>
)
}